import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useRecoilState } from 'recoil';
import { useNavigate } from 'react-router-dom';
import { userAtom, notificationsAtom } from '../../../atoms/Atoms';
import { H2, H4 } from '../../shared-components/typography/Title';
import AuthLayout from '../../shared-components/auth-layout/AuthLayout';
import Button from '../../shared-components/buttons/Button';
import Form from '../../shared-components/form/Form';
import Input from '../../shared-components/form/Input';
import api from '../../../api/api';
import envConfig from '../../../envConfig';

function Recover() {
  const [notifications, setNotifications] = useRecoilState(notificationsAtom);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);
  const [loading, setLoading] = useState(false);

  if (user) {
    window.location = '/home';
  }

  function submit(values) {
    setLoading(true);
    api.post('auth/request/reset', { Email: values.email })
    .then((response) => {
      setLoading(false);
      if (response.data.success) {
        setNotifications([
          ...notifications,
          {
            title: t('yay'),
            description: response.data.message,
            error: false,
          },
        ]);
        navigate('/');
      } else {
        setNotifications([
          ...notifications,
          {
            title: t('error'),
            description: response.data.error,
            error: true,
          },
        ]);
      }
    })
    .catch((error) => {
      setLoading(false);
      setNotifications([
        ...notifications,
        {
          title: t('error'),
          description: error.message,
          error: true,
        },
      ]);
    });
  }

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema: Yup.object().shape({
      email: Yup.string()
        .email(t('valid_email_validation'))
        .required(t('required_field')),
    }),
    onSubmit: (values, { setSubmitting }) => submit(values),
  });

    return (
      <AuthLayout title={`${t('welcome_message')} - ${envConfig.SiteTitle}`}>
          <H2 className="text-center" text={t('enter_email_to_send_instructions')} />
          <Form className="mt-6 w-full space-y-7">
            <Input
              label={t('email')}
              required
              type="email"
              name="email"
              id="email"
              className=""
              autoComplete="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              error={
                formik.errors.email && formik.touched.email && formik.errors.email
              }
            />
          </Form>
          <Button
            className="bg-primaryColor mt-8 mb-3 w-full"
            textColor="text-primaryTextColor"
            loaderColor="bg-primaryTextColor"
            borderColor="border-primaryBorderColor"
            loading={loading}
            text={t('submit')}
            onClick={formik.submitForm}
          />
          <H4 className="mb-3 text-center text-muted" text={t('or')} />
          <Button
            disabled={loading}
            className="bg-transparent shadow-none hover:shadow-none mb-3 w-full"
            textColor="text-secondaryTextColor"
            borderColor="border-secondaryBorderColor"
            text={t('go_back')}
            onClick={() => navigate('/')}
          />
      </AuthLayout>
    );
}

export default Recover;
